<div class="text-center px-5 py-1">
  <div class="mb-3">
    <img src="assets/images/mascotte/404.png" alt="Subscription error" class="img-fluid error">
  </div>
  <h3 class="mb-3 text-muted">
    <span translate>Tu dois être âgé.e de plus de 18 ans...</span>
  </h3>
  <p class="text-muted" translate>
    Les niveaux thématiques offrent du contenu adapté pour les professionnels souhaitant s'exercer et développer leurs compétences dans leur secteur d'activité. Cette thématique comporte du vocabulaire non adapté aux personnes mineures.
  </p>
  <div class="my-2 font-weight-bold">
    <a target="_blank" [href]="configSrv.getPublicUrl('www_contents_legal')" translate>Mentions légales</a> - <a target="_blank"
    [href]="configSrv.getPublicUrl('www_contents_terms')" translate>CGV</a>
  </div>
  <button class="btn btn-primary mb-2" translate (click)="close()">Retour</button>
</div>
